import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcSnsInstagram(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "21",
    height: "21",
    fill: "none",
    viewBox: "0 0 21 21",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#8B8D92",
    fillRule: "evenodd",
    d: "M2.192 2.228C3.331 1.095 4.742.697 6.37.623c9.716-.448 11.157.384 12.383 1.605 1.544 1.543 2.013 3.469 1.61 12.353-.048 1.057-.217 1.778-.463 2.41-1.385 3.546-4.67 3.764-13.53 3.363-1.06-.048-1.781-.216-2.415-.461a5.05 5.05 0 0 1-2.91-2.903C.267 14.998.534 7.402.581 6.396c.073-1.61.466-3.027 1.61-4.168m4.26 16.34c-.97-.044-1.497-.204-1.848-.341a3.26 3.26 0 0 1-1.89-1.884c-.591-1.513-.394-8.702-.342-9.865.052-1.14.282-2.182 1.087-2.985.995-.993 2.28-1.478 11.033-1.084 1.144.052 2.186.282 2.993 1.084.995.992 1.487 2.288 1.087 11.008-.044.968-.206 1.493-.343 1.843-.9 2.307-2.972 2.628-11.777 2.224m9.332-12.187c-.66 0-1.195-.534-1.195-1.19a1.194 1.194 0 0 1 2.389 0c0 .656-.536 1.19-1.194 1.19M5.363 10.488a5.104 5.104 0 0 0 5.109 5.098 5.103 5.103 0 0 0 5.109-5.098 5.103 5.103 0 0 0-5.11-5.097 5.105 5.105 0 0 0-5.108 5.097m1.793 0a3.313 3.313 0 0 1 3.316-3.31 3.313 3.313 0 0 1 3.316 3.31 3.314 3.314 0 0 1-3.316 3.31 3.31 3.31 0 0 1-3.316-3.31",
    clipRule: "evenodd"
  }));
}
var IcSnsInstagram = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSnsInstagram));

export { IcSnsInstagram as I };
